import { render, staticRenderFns } from "./UsersCustomJob.vue?vue&type=template&id=5a7227fd&scoped=true&"
import script from "./UsersCustomJob.vue?vue&type=script&lang=js&"
export * from "./UsersCustomJob.vue?vue&type=script&lang=js&"
import style0 from "./UsersCustomJob.vue?vue&type=style&index=0&id=5a7227fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7227fd",
  null
  
)

export default component.exports